import { Platform, type ViewStyle } from 'react-native';

export function webTransition(transition: string): ViewStyle {
  return Platform.OS === 'web' ? ({ transition } as unknown as ViewStyle) : {};
}
